module.exports = __webpack_public_path__ + "img/download-app-store.d2551d16.png";